import { Directive, inject } from '@angular/core';
import { MatMenuItem } from '@angular/material/menu';

/**
 * Accent-highlighted action item for `mat-menu-item` (styled via `.proffeo-menu-action` in `menu.scss`).
 * Hovering moves focus to the item so the mouse and the keyboard never highlight two items at once.
 */
@Directive({
  selector: '[mat-menu-item][proffeoMenuAction]',
  host: {
    class: 'proffeo-menu-action',
    '(mouseenter)': 'focusOnHover()'
  }
})
export class MenuActionDirective {
  private readonly menuItem: MatMenuItem = inject(MatMenuItem, { self: true });

  protected focusOnHover(): void {
    if (!this.menuItem.disabled) {
      this.menuItem.focus('mouse');
    }
  }
}
